import { CSS } from 'design'

export const container: CSS = {
  boxSizing: 'border-box',
  minWidth: 0,
  color: 'inherit',
}

export const truncate: CSS = {
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}
